export enum AdminFeatureFlags {
    DIRECT_MESSAGES_SETTINGS = "allowDirectChat",
    PRIVATE_GROUPS_SETTINGS = "allowPrivateGroups",
    IMAGES_SETTINGS = "allowImages",
    NEWS_FEED_PAGE = "allowNewsFeed",
}
